import { render, staticRenderFns } from "./MenuLateralDireitoColaborador.vue?vue&type=template&id=51b9bda6&scoped=true"
import script from "./MenuLateralDireitoColaborador.vue?vue&type=script&lang=js"
export * from "./MenuLateralDireitoColaborador.vue?vue&type=script&lang=js"
import style0 from "./MenuLateralDireitoColaborador.vue?vue&type=style&index=0&id=51b9bda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9bda6",
  null
  
)

export default component.exports